import React from "react";
import { Spinner } from "react-bootstrap";

export const LoadingSpinner = ({ className = "mx-auto pt-5 screen-height", style = { width: "2rem" } }) => (
  <div className={className} style={style}>
    <Spinner animation="grow" variant="primary"></Spinner>
  </div>
);

export const LoadingSpinnerLabel = ({ label = "", className = "" }) => (
  <span className={className}>
    <div className="spinner-border text-primary spinner-grow-sm mr-3" />
    {label}
  </span>
);
